import type { ReactNode } from 'react';

export interface LaunchDarklyProviderProps {
  children: ReactNode;
}

export interface LDAnonymousContext {
  kind: 'user';
  anonymous: true;
}

export interface LDIdentifiedContext {
  kind: 'user';
  key: string;
  name: string;
  email: string;
  module?: string;
  customerId?: string;
}

export const ANONYMOUS_CONTEXT: LDAnonymousContext = {
  kind: 'user',
  anonymous: true,
};

export type LDUserContext = LDAnonymousContext | LDIdentifiedContext;
